/** @format */

import {type ViewMode} from 'pages/HomeOverview/types';

import {type KpiChartRow} from './KpiCharts';
import {KpiCharts} from './KpiCharts';
import {KpiTable} from './KpiTable';
import {MediaplanCta} from './MediaplanCta';

interface Props {
  viewMode: ViewMode;
  rows: KpiChartRow[];
  hasMediaplan: boolean;
  planPeriodLabel: string;
  onSetupMediaplan: () => void;
}

/**
 * KPI side of the card body. Renders either:
 *  - the "no mediaplan" CTA (when the project has no mediaplan), or
 *  - the KPI summary table / dynamic charts for ALL of the project's KPI rows.
 *
 * The header KPI filter hides whole projects (see filterProjectsByKpi), it does NOT drop
 * rows here — a visible card always shows every KPI it has.
 */
function KpiSection({viewMode, rows, hasMediaplan, planPeriodLabel, onSetupMediaplan}: Props) {
  if (!hasMediaplan) {
    return <MediaplanCta onSetup={onSetupMediaplan} />;
  }

  if (viewMode === 'summary') {
    return <KpiTable rows={rows} planPeriodLabel={planPeriodLabel} />;
  }

  return <KpiCharts rows={rows} planPeriodLabel={planPeriodLabel} />;
}

export {KpiSection};
